module.exports = __webpack_public_path__ + "static/media/FIL-BNB.73d9b0a2.svg";